// LoomRaga · Raagaa size-guide drawer.
// Opens the per-accessory guide <dialog> via showModal() so it sits in the browser TOP LAYER
// (never blocked by the sticky product column or any z-index). Delegated listeners — one set
// for the whole page, so it works no matter how many guide blocks render.
(function () {
  if (window.__lrSizeGuide) return;
  window.__lrSizeGuide = true;

  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-lr-guide-open]');
    if (opener) {
      const dlg = document.getElementById(opener.getAttribute('aria-controls'));
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg.showModal();
      }
      return;
    }

    const closer = e.target.closest('[data-lr-guide-close]');
    if (closer) {
      const dlg = closer.closest('dialog');
      if (dlg) dlg.close();
      return;
    }

    // Click on the backdrop (target is the dialog element itself) closes it.
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('lr-guide-dialog')) {
      e.target.close();
    }
  });
})();
